"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTransitions = exports.duration = exports.easing = void 0;
// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
exports.easing = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)',
};
// Follow https://material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
// to learn when use what timing
exports.duration = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195,
};
function formatMs(milliseconds) {
    return "".concat(Math.round(milliseconds), "ms");
}
function getAutoHeightDuration(height) {
    if (!height) {
        return 0;
    }
    var constant = height / 36;
    // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
    return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
}
function createTransitions(inputTransitions) {
    var mergedEasing = __assign(__assign({}, exports.easing), inputTransitions.easing);
    var mergedDuration = __assign(__assign({}, exports.duration), inputTransitions.duration);
    var create = function (props, options) {
        if (props === void 0) { props = ['all']; }
        if (options === void 0) { options = {}; }
        var _a = options.duration, durationOption = _a === void 0 ? mergedDuration.standard : _a, _b = options.easing, easingOption = _b === void 0 ? mergedEasing.easeInOut : _b, _c = options.delay, delay = _c === void 0 ? 0 : _c, other = __rest(options, ["duration", "easing", "delay"]);
        if (process.env.NODE_ENV !== 'production') {
            var isString = function (value) { return typeof value === 'string'; };
            // IE11 support, replace with Number.isNaN
            // eslint-disable-next-line no-restricted-globals
            var isNumber = function (value) { return !isNaN(parseFloat(value)); };
            if (!isString(props) && !Array.isArray(props)) {
                console.error('Argument "props" must be a string or Array.');
            }
            if (!isNumber(durationOption) && !isString(durationOption)) {
                console.error("Argument \"duration\" must be a number or a string but found ".concat(durationOption, "."));
            }
            if (!isString(easingOption)) {
                console.error('Argument "easing" must be a string.');
            }
            if (!isNumber(delay) && !isString(delay)) {
                console.error('Argument "delay" must be a number or a string.');
            }
            if (Object.keys(other).length !== 0) {
                console.error("Unrecognized argument(s) [".concat(Object.keys(other).join(','), "]."));
            }
        }
        return (Array.isArray(props) ? props : [props])
            .map(function (animatedProp) {
            return "".concat(animatedProp, " ").concat(typeof durationOption === 'string' ? durationOption : formatMs(durationOption), " ").concat(easingOption, " ").concat(typeof delay === 'string' ? delay : formatMs(delay));
        })
            .join(',');
    };
    return __assign(__assign({ getAutoHeightDuration: getAutoHeightDuration, create: create }, inputTransitions), { easing: mergedEasing, duration: mergedDuration });
}
exports.createTransitions = createTransitions;
//# sourceMappingURL=transitions.js.map